"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Box = _interopRequireDefault(require("./Box"));

var _theme = _interopRequireWildcard(require("./theme"));

var _styledComponents = require("styled-components");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      &:after {\n        content: '\xBB';\n        padding-left: 0.25em;\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      &:before {\n        content: '\xAB';\n        padding-right: 0.25em;\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      transition: ", " all;\n      will-change: transform;\n      transform: scale(1);\n      &:hover,\n      &:focus {\n        transform: scale(", ");\n      }\n      ", " {\n        transform: none;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: ", ";\n  line-height: 1.125;\n  appearance: none;\n  cursor: pointer;\n  transition: ", " box-shadow;\n  box-shadow: 0 2px 4px ", ";\n  border-radius: ", ";\n  border: none;\n\n  ", ";\n\n  &:hover,\n  &:focus {\n    outline: 0;\n    box-shadow: 0 2px 6px\n      ", ";\n  }\n\n  &:active {\n    outline: 0;\n    box-shadow: 0 2px 8px 2px\n      ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Button = _Box["default"].withComponent('a').extend(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.bold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadowColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.pill;
}, function (props) {
  return props.inverted && {
    backgroundColor: (0, _theme.cx)(props.color),
    color: (0, _theme.cx)(props.bg)
  };
}, function (props) {
  return props.inverted ? props.theme.shadowColor : (0, _theme.hexa)(props.bg, 0.25);
}, function (props) {
  return props.inverted ? props.theme.shadowColor : (0, _theme.hexa)(props.bg, 0.25);
}, function (props) {
  return props.disabled && {
    opacity: 0.25,
    cursor: 'not-allowed'
  };
}, function (props) {
  return props.scale && (0, _styledComponents.css)(_templateObject2(), function (_ref5) {
    var theme = _ref5.theme;
    return theme.transition;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.scaleFactor;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.mediaQueries.reduceMotion;
  });
}, function (props) {
  return props.chevronLeft && (0, _styledComponents.css)(_templateObject3());
}, function (props) {
  return props.chevronRight && (0, _styledComponents.css)(_templateObject4());
});

Button.displayName = 'Button';
Button.propTypes = {
  /** flip colors */
  inverted: _propTypes["default"].bool,

  /** add hover/focus animation */
  scale: _propTypes["default"].bool,

  /** add left text arrows */
  chevronLeft: _propTypes["default"].bool,

  /** add right text arrows */
  chevronRight: _propTypes["default"].bool
};
Button.defaultProps = {
  theme: _theme["default"],
  bg: 'primary',
  color: 'white',
  fontSize: 3,
  m: 0,
  px: 3,
  py: 2
};
Button.button = Button.withComponent('button');
Button.input = Button.withComponent('input');
var _default = Button;
exports["default"] = _default;